import { ShieldCheck, SealCheck } from "@phosphor-icons/react";
import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, SectionHeader } from "./primitives";

const Security = () => {
  const config = useSiteConfig();
  return (
    <section id="security" className="relative py-24 lg:py-36 border-t border-line" data-testid="security-section">
      <div className="section-shell">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.3fr] lg:gap-20 items-start">
          <div>
            <SectionHeader
              index={11}
              eyebrow="Security"
              title={<>Security<br />by Design.</>}
              sub="Security is an operating discipline, not a marketing claim. The Jovino approach to protecting the protocol, the treasury and the community."
              testId="security-header"
            />
            <Reveal delay={0.15} className="mt-8">
              <div className="inline-flex items-center gap-3 rounded-lg border border-gold/40 bg-gold/5 px-5 py-4" data-testid="audit-status-banner">
                <SealCheck size={24} className="text-gold shrink-0" aria-hidden="true" />
                <span className="font-mono text-xs sm:text-sm text-gold">{config.auditStatus}</span>
              </div>
            </Reveal>
          </div>
          <div className="grid gap-3 sm:grid-cols-2">
            {config.securityPrinciples.map((item, i) => (
              <Reveal key={item} delay={i * 0.05} y={16} testId={`security-item-${i}`}>
                <div className="card-surface flex items-start gap-4 rounded-lg px-5 py-5 h-full">
                  <ShieldCheck size={22} className="text-teal shrink-0 mt-0.5" aria-hidden="true" />
                  <span className="text-sm text-mist leading-relaxed">{item}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Security;
